export enum InvoiceStateEnum {
  PENDING_PAYMENT = 'pending-payment',
  PAID = 'paid',
  CANCELLED = 'cancelled',
  PARTIAL = 'partial',
  REFUNDED = 'refunded',
}

export interface InvoiceModel {
  id: number;
  code: string;
  number: string;
  date: string;
  state: InvoiceStateEnum;
  edi_file_url?: string;
  edi_uploaded_at?: string | null;
  edi_upload_id?: string;
  pdf_file_url?: string;
  order: number;
  order_code: string;
  store_name: string;
  distributor_supports_edi: boolean;
  due_date: string | null;
  total_with_taxes: number | null;
  is_proforma: boolean;
  is_credit: boolean;
  is_preview: boolean;
  accounted: boolean;
}
